import { connect } from 'redux-bundler-react';
import { Controller, useFormContext } from 'react-hook-form';
import Tooltip from '@components/tooltip/tooltip';
import { Radio, Label } from '@trussworks/react-uswds';
import classNames from 'classnames';
import { useEffect } from 'react';
import FileDownloadList from '../file-download-list/FileDownloadList';

import './yesNoInput.scss';

const YesNoInput = connect(
  ({
    defaultValue,
    fileDownload,
    hint,
    id,
    label,
    name,
    onChange: onChangeCallback,
    readOnly,
    required,
    showOptionalText = true,
    tooltip,
    tooltipClickable,
  }) => {
    const {
      control,
      formState: { errors },
      setValue,
    } = useFormContext();

    const containerStyles = classNames('yes-no-container', {
      error: errors[name],
    });
    const labelStyles = classNames('usa-label', {
      optional: !required && showOptionalText,
      required: required,
    });

    const handleOnChange = (e) => {
      if (readOnly) {
        return;
      }

      const value = e.target.value === 'true' ? true : false;
      onChangeCallback(value);
      setValue(name, value, { shouldValidate: true });
    };

    useEffect(() => {
      if (typeof defaultValue === 'boolean' || typeof defaultValue === 'number') {
        setValue(name, !!defaultValue, { shouldValidate: true });
      }
    }, [defaultValue, name, setValue]);

    return (
      <div className={containerStyles} id={id}>
        <Label className={labelStyles}>
          <span id={`${name}_label`}>{label}</span>
          {tooltip && <Tooltip clickable={tooltipClickable} content={tooltip} header={label} name={name} />}
        </Label>
        {hint && <div className='usa-hint'>{hint}</div>}
        {fileDownload?.length > 0 && <FileDownloadList files={fileDownload} />}
        <Controller
          control={control}
          name={name}
          render={({ field: { ref, value } }) => (
            <div className='yes-no-input-container'>
              <Radio
                checked={value === true}
                disabled={readOnly}
                id={`${id}-yes`}
                inputRef={ref}
                label='Yes'
                name={name}
                onChange={(e) => handleOnChange(e)}
                required={required}
                value={true}
              />
              <Radio
                checked={value === false}
                disabled={readOnly}
                id={`${id}-no`}
                inputRef={ref}
                label='No'
                name={name}
                onChange={(e) => handleOnChange(e)}
                required={required}
                value={false}
              />
            </div>
          )}
        ></Controller>
      </div>
    );
  }
);

export default YesNoInput;
